/* Moteur de filtrage/tri client de la page liste (source lib/filtering.ts +
   CategoryListing + FilterPanel). Facettes marque/énergie/type construites depuis
   les data-attributs (§18.7). Pré-cochage ?marque= / ?type= (§8.4/§14.12). */
(function () {
  var root = document.querySelector('.el-listing');
  if (!root) return;
  var list = root.querySelector('[data-el-list]');
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-el-item]'));
  var empty = root.querySelector('[data-el-empty]');
  var desktopPanel = root.querySelector('.el-listing__aside [data-el-fp]');
  var mobileHost = root.querySelector('[data-el-mobilepanel]');

  // Clone du panneau desktop dans le drawer mobile.
  if (desktopPanel && mobileHost && !mobileHost.children.length) {
    mobileHost.appendChild(desktopPanel.cloneNode(true));
  }
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-el-fp]'));

  var state = { sort: 'popularity', onSale: false, isNew: false, smallPrice: false,
    bogo: false, inStock: false, brands: [], energy: [], types: [], min: null, max: null };

  /* ---- Facettes depuis les items ---- */
  function facet(attr) {
    var map = {};
    items.forEach(function (it) {
      var v = (it.getAttribute(attr) || '').trim();
      if (v) map[v] = (map[v] || 0) + 1;
    });
    return map;
  }
  var brandCounts = facet('data-brand');
  var typeCounts = facet('data-type');
  var energyCounts = facet('data-energy');
  var brandNames = Object.keys(brandCounts).sort(function (a, b) { return a.localeCompare(b, 'fr'); });
  var typeNames = Object.keys(typeCounts).sort(function (a, b) { return a.localeCompare(b, 'fr'); });
  var energyNames = Object.keys(energyCounts).sort();

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

  function fillFacets() {
    panels.forEach(function (panel) {
      // Marque
      var bGrp = panel.querySelector('[data-el-grp="brand"]');
      var bBox = panel.querySelector('[data-facet="brand"]');
      if (bBox) {
        bBox.innerHTML = brandNames.map(function (b) {
          return '<label class="el-check" data-brand-row="' + esc(b.toLowerCase()) + '"><input type="checkbox" data-filter="brand" value="' + esc(b) + '"><span class="el-check__lab">' + esc(b) + '</span><span class="el-check__n">(' + brandCounts[b] + ')</span></label>';
        }).join('');
        if (bGrp) bGrp.hidden = brandNames.length === 0;
        var search = panel.querySelector('[data-el-brandsearch]');
        if (search) search.hidden = brandNames.length <= 6;
      }
      // Énergie
      var eGrp = panel.querySelector('[data-el-grp="energy"]');
      var eBox = panel.querySelector('[data-facet="energy"]');
      if (eBox) {
        eBox.innerHTML = energyNames.map(function (e) {
          return '<button type="button" data-filter="energy" value="' + esc(e) + '" aria-pressed="false">' + esc(e) + '</button>';
        }).join('');
        if (eGrp) eGrp.hidden = energyNames.length === 0;
      }
      // Type
      var tGrp = panel.querySelector('[data-el-grp="type"]');
      var tBox = panel.querySelector('[data-facet="type"]');
      if (tBox) {
        tBox.innerHTML = typeNames.map(function (t) {
          return '<label class="el-check"><input type="checkbox" data-filter="type" value="' + esc(t) + '"><span class="el-check__lab">' + esc(t) + '</span><span class="el-check__n">(' + typeCounts[t] + ')</span></label>';
        }).join('');
        if (tGrp) tGrp.hidden = typeNames.length <= 1;
      }
    });
  }

  /* ---- Pré-cochage depuis l'URL (?marque= / ?type=) ---- */
  function seedFromUrl() {
    var q = new URLSearchParams(location.search);
    var m = q.get('marque') || q.get('vendor') || q.getAll('filter.p.vendor').join(',');
    var t = q.get('type');
    if (m) m.split(',').forEach(function (raw) {
      var w = raw.trim().toLowerCase();
      var hit = brandNames.filter(function (b) { return b.toLowerCase() === w; })[0];
      if (hit && state.brands.indexOf(hit) === -1) state.brands.push(hit);
    });
    if (t) {
      var tw = t.trim().toLowerCase();
      var th = typeNames.filter(function (x) { return x.toLowerCase() === tw; })[0];
      if (th) state.types.push(th);
    }
  }

  /* ---- Filtrage + tri ---- */
  function matches(it) {
    if (state.onSale && it.getAttribute('data-onsale') !== '1') return false;
    if (state.isNew && it.getAttribute('data-new') !== '1') return false;
    if (state.smallPrice && parseInt(it.getAttribute('data-price'), 10) > 3000) return false;
    if (state.bogo && it.getAttribute('data-bogo') !== '1') return false;
    if (state.inStock && it.getAttribute('data-stock') === 'out_of_stock') return false;
    if (state.brands.length && state.brands.indexOf(it.getAttribute('data-brand')) === -1) return false;
    if (state.energy.length && state.energy.indexOf(it.getAttribute('data-energy')) === -1) return false;
    if (state.types.length && state.types.indexOf(it.getAttribute('data-type')) === -1) return false;
    var euros = parseInt(it.getAttribute('data-price'), 10) / 100;
    if (state.min != null && euros < state.min) return false;
    if (state.max != null && euros > state.max) return false;
    return true;
  }
  function sortVal(it, key) {
    if (key === 'price-asc' || key === 'price-desc') return parseInt(it.getAttribute('data-price'), 10);
    if (key === 'discount') return parseInt(it.getAttribute('data-discount'), 10);
    if (key === 'rating') return parseFloat(it.getAttribute('data-rating'));
    return parseInt(it.getAttribute('data-reviews'), 10); // popularity
  }
  function apply() {
    var visible = items.filter(matches);
    var key = state.sort;
    visible.sort(function (a, b) {
      var va = sortVal(a, key), vb = sortVal(b, key);
      return key === 'price-asc' ? va - vb : vb - va;
    });
    items.forEach(function (it) { it.style.display = 'none'; });
    visible.forEach(function (it) { it.style.display = ''; list.appendChild(it); });
    if (empty) { list.appendChild(empty); empty.hidden = visible.length !== 0; }
    // Compteurs
    root.querySelectorAll('[data-el-count],[data-el-count2]').forEach(function (n) { n.textContent = visible.length; });
    var active = countActive();
    root.querySelectorAll('[data-el-activecount]').forEach(function (n) { n.textContent = active; n.hidden = active === 0; });
    panels.forEach(function (p) { var c = p.querySelector('[data-el-clear]'); if (c) c.hidden = active === 0; });
  }
  function countActive() {
    var n = 0;
    if (state.onSale) n++; if (state.isNew) n++; if (state.smallPrice) n++; if (state.bogo) n++;
    if (state.inStock) n++; if (state.brands.length) n++; if (state.energy.length) n++;
    if (state.types.length) n++; if (state.min != null || state.max != null) n++;
    return n;
  }

  /* ---- Sync des contrôles (les 2 panneaux) ---- */
  function syncControls() {
    panels.forEach(function (panel) {
      panel.querySelectorAll('[data-filter="sort"]').forEach(function (s) { s.value = state.sort; });
      ['onSale', 'isNew', 'smallPrice', 'bogo', 'inStock'].forEach(function (k) {
        panel.querySelectorAll('[data-filter="' + k + '"]').forEach(function (c) { c.checked = state[k]; });
      });
      panel.querySelectorAll('[data-filter="brand"]').forEach(function (c) { c.checked = state.brands.indexOf(c.value) !== -1; });
      panel.querySelectorAll('[data-filter="type"]').forEach(function (c) { c.checked = state.types.indexOf(c.value) !== -1; });
      panel.querySelectorAll('[data-filter="energy"]').forEach(function (b) { b.setAttribute('aria-pressed', state.energy.indexOf(b.value) !== -1 ? 'true' : 'false'); });
      panel.querySelectorAll('[data-filter="price"]').forEach(function (r) {
        var mn = r.getAttribute('data-min') === '' ? null : parseInt(r.getAttribute('data-min'), 10);
        var mx = r.getAttribute('data-max') === '' ? null : parseInt(r.getAttribute('data-max'), 10);
        r.checked = mn === state.min && mx === state.max;
      });
    });
  }

  function toggle(arr, v) { var i = arr.indexOf(v); if (i === -1) arr.push(v); else arr.splice(i, 1); }

  /* ---- Délégation d'événements ---- */
  root.addEventListener('change', function (e) {
    var el = e.target.closest('[data-filter]');
    if (!el) return;
    var f = el.getAttribute('data-filter');
    if (f === 'sort') state.sort = el.value;
    else if (f === 'price') { state.min = el.getAttribute('data-min') === '' ? null : parseInt(el.getAttribute('data-min'), 10); state.max = el.getAttribute('data-max') === '' ? null : parseInt(el.getAttribute('data-max'), 10); }
    else if (f === 'brand') toggle(state.brands, el.value);
    else if (f === 'type') toggle(state.types, el.value);
    else if (['onSale', 'isNew', 'smallPrice', 'bogo', 'inStock'].indexOf(f) !== -1) state[f] = el.checked;
    syncControls(); apply();
  });
  root.addEventListener('click', function (e) {
    var eb = e.target.closest('[data-filter="energy"]');
    if (eb) { e.preventDefault(); toggle(state.energy, eb.value); syncControls(); apply(); return; }
    if (e.target.closest('[data-el-clear],[data-el-clear2]')) {
      state = { sort: state.sort, onSale: false, isNew: false, smallPrice: false, bogo: false, inStock: false, brands: [], energy: [], types: [], min: null, max: null };
      syncControls(); apply(); return;
    }
    if (e.target.closest('[data-el-openfilters]')) { var d = root.querySelector('[data-el-fpdrawer]'); if (d) { d.hidden = false; document.body.style.overflow = 'hidden'; } }
    if (e.target.closest('[data-el-closefilters]')) { var dd = root.querySelector('[data-el-fpdrawer]'); if (dd) { dd.hidden = true; document.body.style.overflow = ''; } }
  });
  // Recherche marque
  root.addEventListener('input', function (e) {
    var s = e.target.closest('[data-el-brandsearch]');
    if (!s) return;
    var q = s.value.trim().toLowerCase();
    var box = s.parentElement.querySelector('[data-facet="brand"]');
    box.querySelectorAll('[data-brand-row]').forEach(function (row) {
      row.style.display = row.getAttribute('data-brand-row').indexOf(q) !== -1 ? '' : 'none';
    });
  });

  fillFacets();
  seedFromUrl();
  syncControls();
  apply();
})();
